import { render, staticRenderFns } from "./r-search-config.vue?vue&type=template&id=c6fb8d40"
import script from "./r-search-config.vue?vue&type=script&lang=js"
export * from "./r-search-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6fb8d40')) {
      api.createRecord('c6fb8d40', component.options)
    } else {
      api.reload('c6fb8d40', component.options)
    }
    module.hot.accept("./r-search-config.vue?vue&type=template&id=c6fb8d40", function () {
      api.rerender('c6fb8d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/search/r-search-config.vue"
export default component.exports